import React from 'react';
import Loader from 'components/atoms/loader';
import Pagination from 'components/atoms/pagination';
import { Section } from './styles';

interface AiManagementItemsSectionProps {
  title: string;
  subtitle: React.ReactNode;
  toolbar: React.ReactNode;
  search: React.ReactNode;
  loading: boolean;
  errorMessage: string | null;
  empty: { title: string; text: string } | null;
  page: number;
  perPage: number;
  total: number;
  onPageChange: (page: number) => void;
  children: React.ReactNode;
}

const AiManagementItemsSection: React.FC<AiManagementItemsSectionProps> = ({
  title,
  subtitle,
  toolbar,
  search,
  loading,
  errorMessage,
  empty,
  page,
  perPage,
  total,
  onPageChange,
  children,
}) => {
  const renderBody = () => {
    if (loading) {
      return (
        <div className="py-5">
          <Loader />
        </div>
      );
    }

    if (errorMessage) {
      return (
        <div className="alert alert-warning mb-0" role="alert">
          {errorMessage}
        </div>
      );
    }

    if (empty) {
      return (
        <div className="d-flex flex-grow-1 align-items-center justify-content-center py-5">
          <div className="card border p-4 items-empty text-center">
            <div className="font-weight-bold text-dark mb-1">{empty.title}</div>
            <div className="text-muted">{empty.text}</div>
          </div>
        </div>
      );
    }

    return (
      <>
        {children}
        {total > perPage ? (
          <div className="mt-3">
            <Pagination
              postsPerPage={perPage}
              totalPosts={total}
              currentPage={page}
              paginate={onPageChange}
              firstAndLastPage
            />
          </div>
        ) : null}
      </>
    );
  };

  return (
    <Section className="d-flex flex-column bg-light">
      <div className="items-scroll d-flex flex-column overflow-auto px-5 py-4">
        <h4 className="mb-1 text-dark">{title}</h4>
        <div className="small text-dark mb-4">{subtitle}</div>
        {toolbar}
        {search}
        {renderBody()}
      </div>
    </Section>
  );
};

export default AiManagementItemsSection;
